import { render, staticRenderFns } from "./AnnouncementStrip.vue?vue&type=template&id=0eaa9e6e&scoped=true"
import script from "./AnnouncementStrip.vue?vue&type=script&lang=js"
export * from "./AnnouncementStrip.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementStrip.vue?vue&type=style&index=0&id=0eaa9e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaa9e6e",
  null
  
)

export default component.exports